export class DropdownModelDisabled {
    constructor(public id: number, public text: string, public disabled: boolean) { }
  }
